import { defineMeta } from '@/registry/types';

export const ratingMeta = defineMeta({
  name: 'Rating',
  level: 'atom',
  category: 'input',
  classification: 'themed-mui',
  description: 'Star-based rating input/display. Themed MUI Rating.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Rating',
  muiDocs: 'https://mui.com/material-ui/react-rating/',
  a2uiEquivalent: 'Rating',
  importPath: '@/atoms/Rating',
  optionalProps: ['value', 'defaultValue', 'precision', 'readOnly', 'disabled', 'max'],
  supportedStates: ['default', 'hover', 'readOnly', 'disabled', 'half'],
  designTokens: ['colors'],
  accessibility: ['Rating is a radio group; provide a name and label for forms.'],
  usageExamples: ['<Rating defaultValue={4} precision={0.5} />'],
  antiPatterns: ['Do not use Rating for non-rating numeric input.'],
  llmSafe: true,
  whenToUse: ['Collecting/displaying subjective scores'],
  whenNotToUse: ['Severity (use severity Chip)'],
});

export default ratingMeta;
